// extracted by mini-css-extract-plugin
export var sort = "SortSelect-module--sort--O578k";
export var sortIcon = "SortSelect-module--sortIcon--mgM+s";
export var sortLabel = "SortSelect-module--sortLabel--Q5ZTv";
export var sortSelect = "SortSelect-module--sortSelect--10O9l";